// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"efb90dc2","594":"8a9e5e6c","766":"d6ae9d0a","970":"1995c076"}[chunkId] + ".chunk.js";
};